(function () {
  "use strict";

  if (window.__ecoModelBuybackLoaded) return;
  window.__ecoModelBuybackLoaded = true;

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $all(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector)
    );
  }

  /*
   * ============================================================
   * AUTOMATIKUS KÉSZÜLÉKKÉPEK
   * ============================================================
   */

  var modelImages = {
    "iPhone 17 Pro Max":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/IMG_0560.webp?v=1770413286",

    "iPhone 17 Pro":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/IMG_0559.webp?v=1770413286",

    "iPhone 17":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/IMG_0558.webp?v=1770413286",

    "iPhone Air":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/IMG_0557.webp?v=1770413285",

    "iPhone 16e":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/image5.jpg?v=1756759106",

    "iPhone 16 Pro Max":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/image7.jpg?v=1756757823",

    "iPhone 16 Pro":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/image6.jpg?v=1756757789",

    "iPhone 16 Plus":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/image1.jpg?v=1756755651",

    "iPhone 16":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/image1.jpg?v=1756755651",

    "iPhone 15 Pro Max":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_15_Pro_Max_-_Black_Titanium_-_Overlap_Trans-cropped_a7a9450f-79ec-43ab-93bd-d24e5d77b7ce.webp?v=1742388570",

    "iPhone 15 Pro":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_15_Pro_-_Black_titanium-_Overlap_Trans-cropped_c47e786c-4113-4fb6-b720-5670985120cc.webp?v=1742388570",

    "iPhone 15 Plus":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_15_-_Black_-_Overlap_Trans-cropped.webp?v=1742390891",

    "iPhone 15":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_15_-_Black_-_Overlap_Trans-cropped.webp?v=1742390891",

    "iPhone 14 Pro Max":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_14_Pro_Max_-_Black_-_Overlap_Trans-cropped.webp?v=1742391065",

    "iPhone 14 Pro":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_14_Pro_Max_-_Black_-_Overlap_Trans-cropped.webp?v=1742391065",

    "iPhone 14 Plus":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_14_-_Black_-_Overlap_Trans-cropped_a3afa9da-f115-4a37-9ebc-6df335ac686f.webp?v=1742391257",

    "iPhone 14":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_14_-_Black_-_Overlap_Trans-cropped_a3afa9da-f115-4a37-9ebc-6df335ac686f.webp?v=1742391257",

    "iPhone 13 Pro Max":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_13_Pro_Max_-_Black_-_Overlap_Trans-cropped_7531de39-1a8e-4efc-8898-ce0143538e8e.webp?v=1742388570",

    "iPhone 13 Pro":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_13_Pro_-_Black_-_Overlap_Trans-cropped_15898d1b-010e-4167-8194-53fb0619264d.webp?v=1742388570",

    "iPhone 13 Mini":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_13_Mini_-_Black_-_Overlap_Trans-cropped_efa61981-1000-4a8f-83ef-a67189218e31.webp?v=1742388570",

    "iPhone 13":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_13_-_Black_-_Overlap_Trans-cropped_afb14423-b817-4bcc-bb23-8a2407567f18.webp?v=1742388570",

    "iPhone 12 Pro Max":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_12_Pro_Max_-_Black_-_Overlap_Trans-cropped_e09c64b4-92f8-45e7-a8e3-3e03424841f1.webp?v=1742388570",

    "iPhone 12 Pro":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_12_Pro_-_Black_-_Overlap_Trans-cropped_30088212-f9d7-4865-9dc0-9c520d3c4a8e.webp?v=1742388570",

    "iPhone 12 Mini":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_12_Mini_-_Black_-_Overlap_Trans-cropped_d9eda54c-065b-4f4c-891f-e4dbef8903eb.webp?v=1742388570",

    "iPhone 12":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_12_-_Black_-_Overlap_Trans-cropped_3501494a-71c1-44ff-b496-c5ce57835e47.webp?v=1742388570",

    "iPhone 11 Pro Max":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_11_Pro_Max_-_Black_-_Overlap_Trans-cropped_551b0f50-18cc-402d-8882-368a542b3e99_1.webp?v=1742392878",

    "iPhone 11 Pro":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_11_Pro_-_Black_-_Overlap_Trans-cropped_f2132f29-1bd7-4d15-ba97-a781c1b64827.webp?v=1742388569",

    "iPhone 11":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_11_-_Black_-_Overlap_Trans-cropped_1b1edca0-0b97-4b08-81d9-00f0163879d3.webp?v=1742388570",

    "iPhone XS Max":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XS_Max_-_Space_Grey-_Overlap_Trans-cropped.webp?v=1742388570",

    "iPhone Xs Max":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XS_Max_-_Space_Grey-_Overlap_Trans-cropped.webp?v=1742388570",

    "iPhone XS":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XS_-_Space_Grey-_Overlap_Trans-cropped.webp?v=1742388570",

    "iPhone Xs":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XS_-_Space_Grey-_Overlap_Trans-cropped.webp?v=1742388570",

    "iPhone XR":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XR_-_Black-_Overlap_Trans-cropped_36ba490b-723f-4c67-a3f2-fdb5a244c315.webp?v=1742388570",

    "iPhone X":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XS_-_Space_Grey-_Overlap_Trans-cropped.webp?v=1742388570",

    "iPhone 8 Plus":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_SE_2nd_Gen_-_Black-_Overlap_Trans-cropped_b1988eb1-da2e-4337-918a-99e1010819db.webp?v=1742388570",

    "iPhone 8":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_SE_2nd_Gen_-_Black-_Overlap_Trans-cropped_b1988eb1-da2e-4337-918a-99e1010819db.webp?v=1742388570",

    "iPhone SE (2020)":
      "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_SE_2nd_Gen_-_Black-_Overlap_Trans-cropped_b1988eb1-da2e-4337-918a-99e1010819db.webp?v=1742388570"
  };


  /*
   * ============================================================
   * INDÍTÁS
   * ============================================================
   */

  function init() {
    var card = $(".eco-bb-calculator-card");

    if (!card) return;

    var modelEl =
      $(".eco-bb-preview-row strong", card);

    var modelName =
      modelEl
        ? modelEl.textContent.trim()
        : getModelFromHeading();

    if (!modelName) {
      modelName = "iPhone 15 Pro";
    }

    /*
     * HERO kép automatikus cseréje
     */
    applyHeroImage(modelName);

    /*
     * Kalkulátor indítása
     */
    waitForPriceData(
      card,
      modelName
    );
  }


  function getModelFromHeading() {
    var h1 =
      $(".eco-bb-hero h1");

    if (!h1) return "";

    return h1.textContent
      .replace(/felvásárlás/gi, "")
      .trim();
  }


  /*
   * ============================================================
   * HERO KÉP
   * ============================================================
   */

  function getModelImage(modelName) {
    if (
      modelImages[modelName]
    ) {
      return modelImages[
        modelName
      ];
    }

    var normalized =
      normalize(modelName);

    var keys =
      Object.keys(modelImages);

    for (
      var i = 0;
      i < keys.length;
      i++
    ) {
      if (
        normalize(keys[i]) ===
        normalized
      ) {
        return modelImages[
          keys[i]
        ];
      }
    }

    return "";
  }


  function applyHeroImage(modelName) {
    var hero =
      $(".eco-bb-hero-visual");

    if (!hero) return;

    var imageUrl =
      getModelImage(modelName);

    /*
     * Ha nincs automatikus kép,
     * meghagyjuk a kézzel beállítottat.
     */
    if (!imageUrl) return;

    /*
     * Először betöltjük a képet,
     * csak sikeres betöltés után cserélünk.
     */
    var preload =
      new Image();

    preload.onload =
      function () {

        var existingImage =
          $(".eco-bb-phone-image", hero);

        var placeholder =
          $(".eco-bb-image-placeholder", hero);

        /*
         * Új wrapper
         */
        var wrapper =
          document.createElement(
            "div"
          );

        wrapper.className =
          "eco-bb-phone-image eco-bb-auto-phone-image";

        /*
         * Új kép
         */
        var img =
          document.createElement(
            "img"
          );

        img.src =
          imageUrl;

        img.alt =
          modelName;

        img.loading =
          "eager";

        img.decoding =
          "async";

        img.setAttribute(
          "width",
          "900"
        );

        img.setAttribute(
          "height",
          "900"
        );

        wrapper.appendChild(
          img
        );

        /*
         * Régi képet vagy
         * placeholdert eltávolítjuk
         */
        if (existingImage) {
          existingImage.remove();
        }

        if (placeholder) {
          placeholder.remove();
        }

        /*
         * Floating card elé kerül
         */
        var floating =
          $(".eco-bb-floating-card", hero);

        if (floating) {
          hero.insertBefore(
            wrapper,
            floating
          );
        } else {
          hero.appendChild(
            wrapper
          );
        }
      };

    preload.src =
      imageUrl;
  }


  /*
   * ============================================================
   * ÁRLISTA BETÖLTÉSE
   * ============================================================
   */

  function waitForPriceData(
    card,
    modelName
  ) {
    var tries = 0;

    var timer =
      setInterval(
        function () {

          var data =
            window.BUYBACK_PRICE_DATA &&
            Array.isArray(
              window.BUYBACK_PRICE_DATA.items
            )
              ? window.BUYBACK_PRICE_DATA.items
              : window.IPHONE_BUYBACK_PRICELIST;

          if (
            Array.isArray(data) &&
            data.length
          ) {
            clearInterval(
              timer
            );

            buildCalculator(
              card,
              modelName,
              data
            );

            return;
          }

          tries++;

          if (tries > 80) {
            clearInterval(
              timer
            );

            card.innerHTML =
              '<div class="eco-mc-error">' +
                "<strong>Az árlista nem töltődött be.</strong>" +
                "<span>Kérjük, frissítsd az oldalt.</span>" +
              "</div>";
          }

        },
        100
      );
  }


  /*
   * ============================================================
   * KALKULÁTOR
   * ============================================================
   */

  function buildCalculator(
    card,
    modelName,
    allItems
  ) {

    var normalizedModel =
      normalize(modelName);

    var items =
      allItems.filter(
        function (item) {
          return (
            normalize(
              item.Model
            ) ===
              normalizedModel &&
            Number(
              item.BasePriceFt || 0
            ) > 0
          );
        }
      );


    if (!items.length) {

      card.innerHTML =
        '<div class="eco-mc-error">' +
          "<strong>Ehhez a modellhez jelenleg nincs online ár.</strong>" +
          "<span>Kérj személyes ajánlatot üzletünkben.</span>" +
        "</div>";

      return;
    }


    var storages =
      unique(
        items.map(
          function (item) {
            return Number(
              item.StorageGB
            );
          }
        )
      )
        .filter(
          function (value) {
            return (
              isFinite(value) &&
              value > 0
            );
          }
        )
        .sort(
          function (a, b) {
            return a - b;
          }
        );


    /*
     * Nincs automatikus tárhely.
     * A látogatónak kell kiválasztania.
     */
    var state = {

      model:
        modelName,

      storage:
        null,

      battery:
        85,

      picks: {

        kijelzo:
          "D_Kijelzo_Karcmentes_Ft",

        keret:
          "D_Keret_Szep_Ft",

        hatlap:
          "D_Hatlap_Szep_Ft",

        beeges:
          "D_Beeges_Nincs_Ft",

        pixel:
          "D_Pixelhiba_Nincs_Ft",

        tartozek:
          "D_Tartozek_Megvan_Ft"

      }

    };


    var conditions = {

      kijelzo: [

        {
          value:
            "D_Kijelzo_Karcmentes_Ft",
          label:
            "Karcmentes",
          sub:
            "Szép kijelző"
        },

        {
          value:
            "D_Kijelzo_MinKarc_Ft",
          label:
            "Mini karc",
          sub:
            "Apró használati nyom"
        },

        {
          value:
            "D_Kijelzo_Karcos_Ft",
          label:
            "Karcos",
          sub:
            "Látható karcok"
        },

        {
          value:
            "D_Kijelzo_Torett_Ft",
          label:
            "Törött",
          sub:
            "Sérült kijelző"
        }

      ],


      keret: [

        {
          value:
            "D_Keret_Szep_Ft",
          label:
            "Szép",
          sub:
            "Normál állapot"
        },

        {
          value:
            "D_Keret_Karcos_Ft",
          label:
            "Karcos",
          sub:
            "Használati nyomok"
        },

        {
          value:
            "D_Keret_Serult_Ft",
          label:
            "Sérült",
          sub:
            "Ütődés vagy sérülés"
        }

      ],


      hatlap: [

        {
          value:
            "D_Hatlap_Szep_Ft",
          label:
            "Szép",
          sub:
            "Normál állapot"
        },

        {
          value:
            "D_Hatlap_Karcos_Ft",
          label:
            "Karcos",
          sub:
            "Látható karcok"
        },

        {
          value:
            "D_Hatlap_Torett_Ft",
          label:
            "Repedt",
          sub:
            "Repedt vagy törött"
        }

      ],


      beeges: [

        {
          value:
            "D_Beeges_Nincs_Ft",
          label:
            "Nincs",
          sub:
            "Nincs kijelzőbeégés"
        },

        {
          value:
            "D_Beeges_Van_Ft",
          label:
            "Van",
          sub:
            "Látható beégés"
        }

      ],


      pixel: [

        {
          value:
            "D_Pixelhiba_Nincs_Ft",
          label:
            "Nincs",
          sub:
            "Nincs pixelhiba"
        },

        {
          value:
            "D_Pixelhiba_Van_Ft",
          label:
            "Van",
          sub:
            "Pixelhiba található"
        }

      ],


      tartozek: [

        {
          value:
            "D_Tartozek_Megvan_Ft",
          label:
            "Megvan",
          sub:
            "Doboz vagy tartozék"
        },

        {
          value:
            "D_Tartozek_Nincs_Ft",
          label:
            "Nincs",
          sub:
            "Tartozék nélkül"
        }

      ]

    };


    card.innerHTML =

      '<div class="eco-mc">' +

        '<div class="eco-mc-heading">' +

          '<div class="eco-bb-section-label">' +
            "ONLINE ÁRBECSLÉS" +
          "</div>" +

          "<h2>" +
            "Mennyit ér az " +
            escapeHtml(
              modelName
            ) +
            " készüléked?" +
          "</h2>" +

          "<p>" +
            "Állítsd be készüléked adatait, és azonnal megmutatjuk a várható felvásárlási árat." +
          "</p>" +

        "</div>" +


        '<div class="eco-mc-model">' +

          '<span class="eco-mc-caption">' +
            "Kiválasztott készülék" +
          "</span>" +

          "<strong>" +
            escapeHtml(
              modelName
            ) +
          "</strong>" +

        "</div>" +


        buildStorageHtml(
          storages
        ) +


        buildBatteryHtml(
          state.battery
        ) +


        buildConditionSection(
          "kijelzo",
          "Kijelző állapota",
          conditions.kijelzo,
          state
        ) +


        buildConditionSection(
          "keret",
          "Keret állapota",
          conditions.keret,
          state
        ) +


        buildConditionSection(
          "hatlap",
          "Hátlap állapota",
          conditions.hatlap,
          state
        ) +


        buildConditionSection(
          "beeges",
          "Kijelző beégés",
          conditions.beeges,
          state
        ) +


        buildConditionSection(
          "pixel",
          "Pixelhiba",
          conditions.pixel,
          state
        ) +


        buildConditionSection(
          "tartozek",
          "Tartozékok",
          conditions.tartozek,
          state
        ) +


        '<div class="eco-mc-offer">' +

          '<div class="eco-mc-offer-top">' +

            "<div>" +

              '<span class="eco-mc-offer-label">' +
                "Várható felvásárlási ár" +
              "</span>" +

              '<strong class="eco-mc-price">' +
                "Válassz tárhelyet" +
              "</strong>" +

            "</div>" +

            '<div class="eco-mc-offer-icon">' +
              "✓" +
            "</div>" +

          "</div>" +


          '<div class="eco-mc-selected">' +
            escapeHtml(
              modelName
            ) +
          "</div>" +


          '<p class="eco-mc-disclaimer">' +

            "A megjelenített összeg tájékoztató jellegű. " +
            "A végleges ajánlat személyes bevizsgálás után kerül meghatározásra." +

          "</p>" +


          '<div class="eco-mc-actions">' +

            '<a class="eco-mc-action-main" ' +
              'href="tel:+36705525552">' +
              "Hívás most" +
            "</a>" +

            '<a class="eco-mc-action-secondary" ' +
              'href="https://www.google.com/maps/search/?api=1&query=Eco+Mobil+Etele+Plaza" ' +
              'target="_blank" ' +
              'rel="noopener">' +
              "Útvonal az üzlethez" +
            "</a>" +

          "</div>" +

        "</div>" +

      "</div>";


    addStyles();

    wireStorage(
      card,
      state,
      items
    );

    wireBattery(
      card,
      state,
      items
    );

    wireConditions(
      card,
      state,
      items
    );

    updatePrice(
      card,
      state,
      items
    );
  }


  /*
   * ============================================================
   * TÁRHELY
   * ============================================================
   */

  function buildStorageHtml(
    storages
  ) {

    var html =

      '<div class="eco-mc-group">' +

        '<div class="eco-mc-group-head">' +

          '<span class="eco-mc-step">' +
            "01" +
          "</span>" +

          "<div>" +

            "<strong>" +
              "Tárhely" +
            "</strong>" +

            "<small>" +
              "Válaszd ki a készülék kapacitását" +
            "</small>" +

          "</div>" +

        "</div>" +


        '<div class="eco-mc-options eco-mc-storage-options">';


    storages.forEach(
      function (storage) {

        html +=

          '<button type="button" ' +

            'class="eco-mc-option eco-mc-storage" ' +

            'data-storage="' +
              storage +
            '">' +

            '<span class="eco-mc-check">' +
              "✓" +
            "</span>" +

            "<strong>" +
              storage +
              " GB" +
            "</strong>" +

          "</button>";

      }
    );


    html +=
      "</div>" +
      "</div>";


    return html;
  }


  /*
   * ============================================================
   * AKKUMULÁTOR
   * ============================================================
   */

  function buildBatteryHtml(
    percent
  ) {

    return (

      '<div class="eco-mc-group">' +

        '<div class="eco-mc-group-head">' +

          '<span class="eco-mc-step">' +
            "02" +
          "</span>" +

          "<div>" +

            "<strong>" +
              "Akkumulátor állapota" +
            "</strong>" +

            "<small>" +
              "Állítsd be az akkumulátor százalékát" +
            "</small>" +

          "</div>" +

        "</div>" +


        '<div class="eco-mc-battery-box">' +

          '<div class="eco-mc-battery-top">' +

            "<div>" +

              '<span class="eco-mc-caption">' +
                "Akkumulátor" +
              "</span>" +

              '<strong class="eco-mc-battery-text">' +
                percent +
                "%" +
              "</strong>" +

            "</div>" +

            '<span class="eco-mc-battery-status ' +
              batteryTone(
                percent
              ) +
            '">' +

              batteryLabel(
                percent
              ) +

            "</span>" +

          "</div>" +


          '<input ' +

            'class="eco-mc-range" ' +

            'type="range" ' +

            'min="0" ' +

            'max="100" ' +

            'step="1" ' +

            'value="' +
              percent +
            '">' +


          '<div class="eco-mc-range-scale">' +

            "<span>0%</span>" +

            "<span>70%</span>" +

            "<span>80%</span>" +

            "<span>100%</span>" +

          "</div>" +

        "</div>" +

      "</div>"

    );
  }


  /*
   * ============================================================
   * ÁLLAPOT BLOKKOK
   * ============================================================
   */

  function buildConditionSection(
    key,
    title,
    choices,
    state
  ) {

    var stepNumbers = {

      kijelzo:
        "03",

      keret:
        "04",

      hatlap:
        "05",

      beeges:
        "06",

      pixel:
        "07",

      tartozek:
        "08"

    };


    var html =

      '<div class="eco-mc-group">' +

        '<div class="eco-mc-group-head">' +

          '<span class="eco-mc-step">' +

            stepNumbers[
              key
            ] +

          "</span>" +

          "<div>" +

            "<strong>" +
              escapeHtml(
                title
              ) +
            "</strong>" +

            "<small>" +
              "Válaszd ki a megfelelő állapotot" +
            "</small>" +

          "</div>" +

        "</div>" +


        '<div class="eco-mc-options">';


    choices.forEach(
      function (choice) {

        var active =
          state.picks[
            key
          ] ===
          choice.value;


        html +=

          '<button type="button" ' +

            'class="eco-mc-option ' +
              (
                active
                  ? "is-active"
                  : ""
              ) +
            '" ' +

            'data-condition-group="' +
              escapeHtml(
                key
              ) +
            '" ' +

            'data-condition-value="' +
              escapeHtml(
                choice.value
              ) +
            '">' +

            '<span class="eco-mc-check">' +
              "✓" +
            "</span>" +

            "<strong>" +
              escapeHtml(
                choice.label
              ) +
            "</strong>" +

            "<small>" +
              escapeHtml(
                choice.sub
              ) +
            "</small>" +

          "</button>";

      }
    );


    html +=
      "</div>" +
      "</div>";


    return html;
  }


  /*
   * ============================================================
   * EVENTEK
   * ============================================================
   */

  function wireStorage(
    card,
    state,
    items
  ) {

    var buttons =
      $all(
        ".eco-mc-storage",
        card
      );


    buttons.forEach(
      function (button) {

        button.addEventListener(
          "click",
          function () {

            state.storage =
              Number(
                this.getAttribute(
                  "data-storage"
                )
              );


            buttons.forEach(
              function (btn) {
                btn.classList.remove(
                  "is-active"
                );
              }
            );


            this.classList.add(
              "is-active"
            );


            updatePrice(
              card,
              state,
              items
            );
          }
        );

      }
    );
  }


  function wireBattery(
    card,
    state,
    items
  ) {

    var slider =
      $(".eco-mc-range", card);


    if (!slider) return;


    slider.addEventListener(
      "input",
      function () {

        state.battery =
          Number(
            this.value
          );


        var text =
          $(".eco-mc-battery-text", card);


        var status =
          $(".eco-mc-battery-status", card);


        if (text) {
          text.textContent =
            state.battery +
            "%";
        }


        if (status) {

          status.textContent =
            batteryLabel(
              state.battery
            );


          status.className =
            "eco-mc-battery-status " +
            batteryTone(
              state.battery
            );
        }


        updatePrice(
          card,
          state,
          items
        );
      }
    );
  }


  function wireConditions(
    card,
    state,
    items
  ) {

    var buttons =
      $all(
        "[data-condition-group]",
        card
      );


    buttons.forEach(
      function (button) {

        button.addEventListener(
          "click",
          function () {

            var group =
              this.getAttribute(
                "data-condition-group"
              );


            var value =
              this.getAttribute(
                "data-condition-value"
              );


            state.picks[
              group
            ] =
              value;


            $all(
              '[data-condition-group="' +
                group +
              '"]',
              card
            ).forEach(
              function (btn) {

                btn.classList.remove(
                  "is-active"
                );

              }
            );


            this.classList.add(
              "is-active"
            );


            updatePrice(
              card,
              state,
              items
            );

          }
        );

      }
    );
  }


  /*
   * ============================================================
   * ÁRSZÁMÍTÁS
   * ============================================================
   */

  function selectedItem(
    state,
    items
  ) {

    if (
      state.storage ===
        null ||
      typeof state.storage ===
        "undefined"
    ) {
      return null;
    }


    var storage =
      Number(
        state.storage
      );


    for (
      var i = 0;
      i < items.length;
      i++
    ) {

      if (
        Number(
          items[i].StorageGB
        ) ===
        storage
      ) {
        return items[i];
      }

    }


    return null;
  }


  function updatePrice(
    card,
    state,
    items
  ) {

    var priceEl =
      $(".eco-mc-price", card);


    var selectedEl =
      $(".eco-mc-selected", card);


    if (!priceEl) return;


    var item =
      selectedItem(
        state,
        items
      );


    if (!item) {

      priceEl.textContent =
        "Válassz tárhelyet";


      if (selectedEl) {
        selectedEl.textContent =
          state.model;
      }


      return;
    }


    var deductionKeys = [

      batteryKey(
        state.battery
      ),

      state.picks.kijelzo,

      state.picks.keret,

      state.picks.hatlap,

      state.picks.beeges,

      state.picks.pixel,

      state.picks.tartozek

    ];


    var totalDeduction =
      0;


    var individualOffer =
      false;


    deductionKeys.forEach(
      function (key) {

        var deduction =
          getDeduction(
            item,
            key
          );


        if (
          deduction ===
          "X"
        ) {

          individualOffer =
            true;

        } else {

          totalDeduction +=
            deduction;

        }

      }
    );


    if (
      individualOffer
    ) {

      priceEl.textContent =
        "Egyedi ajánlat";


      if (selectedEl) {

        selectedEl.textContent =
          state.model +
          " • " +
          item.StorageGB +
          " GB";

      }


      return;
    }


    var basePrice =
      Number(
        item.BasePriceFt || 0
      );


    var offer =
      Math.max(
        0,
        basePrice -
          totalDeduction
      );


    priceEl.textContent =
      formatFt(
        offer
      );


    if (selectedEl) {

      selectedEl.textContent =
        state.model +
        " • " +
        item.StorageGB +
        " GB • Akku " +
        state.battery +
        "%";

    }
  }


  function getDeduction(
    item,
    key
  ) {

    if (
      !item ||
      !key
    ) {
      return 0;
    }


    var value =
      item[key];


    if (
      value === null ||
      typeof value ===
        "undefined" ||
      value === ""
    ) {
      return 0;
    }


    if (
      String(value)
        .trim()
        .toLowerCase() ===
      "x"
    ) {
      return "X";
    }


    var number =
      Number(
        String(value)
          .replace(
            "−",
            "-"
          )
          .replace(
            /[^0-9-]/g,
            ""
          )
      );


    if (
      !isFinite(number)
    ) {
      return 0;
    }


    return Math.abs(
      number
    );
  }


  /*
   * ============================================================
   * AKKU LOGIKA
   * ============================================================
   */

  function batteryKey(
    percent
  ) {

    percent =
      Number(
        percent
      );


    if (
      percent >= 85
    ) {
      return "D_Akku_Jo_Ft";
    }


    if (
      percent >= 80
    ) {
      return "D_Akku_Elfogadhato_Ft";
    }


    return "D_Akku_Cseres_Ft";
  }


  function batteryLabel(
    percent
  ) {

    percent =
      Number(
        percent
      );


    if (
      percent >= 85
    ) {
      return "Jó";
    }


    if (
      percent >= 80
    ) {
      return "Elfogadható";
    }


    return "Cserés";
  }


  function batteryTone(
    percent
  ) {

    percent =
      Number(
        percent
      );


    if (
      percent < 70
    ) {
      return "is-bad";
    }


    if (
      percent < 80
    ) {
      return "is-warn";
    }


    return "is-good";
  }


  /*
   * ============================================================
   * SEGÉDFÜGGVÉNYEK
   * ============================================================
   */

  function normalize(
    value
  ) {

    return String(
      value || ""
    )
      .trim()
      .toLowerCase()
      .replace(
        /\s+/g,
        " "
      );
  }


  function unique(
    array
  ) {

    return array.filter(
      function (
        value,
        index
      ) {

        return (
          array.indexOf(
            value
          ) ===
          index
        );

      }
    );
  }


  function formatFt(
    value
  ) {

    try {

      return (
        new Intl.NumberFormat(
          "hu-HU"
        ).format(
          value
        ) +
        " Ft"
      );

    } catch (error) {

      return (
        value +
        " Ft"
      );

    }
  }


  function escapeHtml(
    value
  ) {

    return String(
      value || ""
    ).replace(
      /[&<>"']/g,
      function (char) {

        return {

          "&":
            "&amp;",

          "<":
            "&lt;",

          ">":
            "&gt;",

          '"':
            "&quot;",

          "'":
            "&#039;"

        }[char];

      }
    );
  }


  /*
   * ============================================================
   * KALKULÁTOR DESIGN
   * ============================================================
   */

  function addStyles() {

    if (
      document.getElementById(
        "ecoModelCalcStyles"
      )
    ) {
      return;
    }


    var style =
      document.createElement(
        "style"
      );


    style.id =
      "ecoModelCalcStyles";


    style.textContent = `

      .eco-mc {
        width: 100%;
      }

      .eco-mc-heading {
        margin-bottom: 30px;
      }

      .eco-mc-heading h2 {
        margin-bottom: 12px !important;
      }

      .eco-mc-heading p {
        margin: 0;
        color: #667085;
        line-height: 1.65;
      }

      .eco-mc-model {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        margin-bottom: 16px;
        padding: 18px 20px;
        border: 1px solid rgba(16,24,40,.08);
        border-radius: 15px;
        background:
          linear-gradient(
            135deg,
            #f8fafc,
            #f1faf6
          );
      }

      .eco-mc-model strong {
        font-size: 18px;
        color: #101828;
      }

      .eco-mc-caption {
        display: block;
        color: #667085;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .04em;
      }

      .eco-mc-group {
        padding: 24px 0;
        border-bottom:
          1px solid rgba(16,24,40,.08);
      }

      .eco-mc-group-head {
        display: flex;
        align-items: center;
        gap: 14px;
        margin-bottom: 18px;
      }

      .eco-mc-step {
        width: 40px;
        height: 40px;
        flex: 0 0 40px;
        display: grid;
        place-items: center;
        border-radius: 50%;
        background: #ecfdf5;
        color: #047857;
        font-size: 12px;
        font-weight: 900;
      }

      .eco-mc-group-head strong,
      .eco-mc-group-head small {
        display: block;
      }

      .eco-mc-group-head strong {
        color: #101828;
        font-size: 15px;
      }

      .eco-mc-group-head small {
        margin-top: 3px;
        color: #667085;
        font-size: 11px;
      }

      .eco-mc-options {
        display: grid;
        grid-template-columns:
          repeat(
            3,
            minmax(0,1fr)
          );
        gap: 10px;
      }

      .eco-mc-storage-options {
        grid-template-columns:
          repeat(
            4,
            minmax(0,1fr)
          );
      }

      .eco-mc-option {
        position: relative;
        min-height: 82px;
        padding: 14px;
        border:
          1px solid rgba(16,24,40,.10);
        border-radius: 13px;
        background: #fff;
        color: #101828;
        cursor: pointer;
        text-align: left;
        transition:
          border-color .18s ease,
          background .18s ease,
          transform .18s ease,
          box-shadow .18s ease;
      }

      .eco-mc-storage {
        min-height: 58px;
        text-align: center;
      }

      .eco-mc-option:hover {
        transform:
          translateY(-1px);
        border-color:
          rgba(5,150,105,.35);
        box-shadow:
          0 8px 22px rgba(15,23,42,.06);
      }

      .eco-mc-option.is-active {
        border-color: #059669;
        background:
          linear-gradient(
            135deg,
            #ecfdf5,
            #f7fffb
          );
        box-shadow:
          inset 0 0 0 1px
          rgba(5,150,105,.12);
      }

      .eco-mc-option strong,
      .eco-mc-option small {
        display: block;
      }

      .eco-mc-option strong {
        font-size: 13px;
      }

      .eco-mc-option small {
        margin-top: 5px;
        color: #667085;
        font-size: 10px;
      }

      .eco-mc-check {
        position: absolute;
        top: 8px;
        right: 9px;
        width: 20px;
        height: 20px;
        display: none;
        place-items: center;
        border-radius: 50%;
        background: #059669;
        color: #fff;
        font-size: 11px;
        font-weight: 900;
      }

      .eco-mc-option.is-active
      .eco-mc-check {
        display: grid;
      }

      .eco-mc-battery-box {
        padding: 20px;
        border:
          1px solid rgba(16,24,40,.08);
        border-radius: 16px;
        background: #f8fafc;
      }

      .eco-mc-battery-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
      }

      .eco-mc-battery-top strong {
        display: block;
        margin-top: 4px;
        color: #047857;
        font-size: 26px;
      }

      .eco-mc-battery-status {
        padding: 7px 12px;
        border-radius: 999px;
        background: #dcfce7;
        color: #166534;
        font-size: 11px;
        font-weight: 800;
      }

      .eco-mc-battery-status.is-warn {
        background: #fef3c7;
        color: #92400e;
      }

      .eco-mc-battery-status.is-bad {
        background: #fee2e2;
        color: #991b1b;
      }

      .eco-mc-range {
        width: 100%;
        cursor: pointer;
        accent-color: #059669;
      }

      .eco-mc-range-scale {
        display: flex;
        justify-content: space-between;
        margin-top: 6px;
        color: #98a2b3;
        font-size: 9px;
      }

      .eco-mc-offer {
        margin-top: 26px;
        padding: 26px;
        border-radius: 20px;
        background:
          linear-gradient(
            135deg,
            #047857,
            #059669
          );
        color: #fff;
        box-shadow:
          0 18px 45px
          rgba(5,150,105,.22);
      }

      .eco-mc-offer-top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 20px;
      }

      .eco-mc-offer-label {
        display: block;
        margin-bottom: 6px;
        opacity: .78;
        font-size: 11px;
        font-weight: 700;
      }

      .eco-mc-price {
        display: block;
        font-size:
          clamp(27px,4vw,40px);
        line-height: 1;
        letter-spacing: -.04em;
      }

      .eco-mc-offer-icon {
        width: 42px;
        height: 42px;
        flex: 0 0 42px;
        display: grid;
        place-items: center;
        border-radius: 50%;
        background:
          rgba(255,255,255,.16);
        font-weight: 900;
      }

      .eco-mc-selected {
        margin-top: 12px;
        color:
          rgba(255,255,255,.84);
        font-size: 12px;
      }

      .eco-mc-disclaimer {
        margin:
          18px 0 0 !important;
        padding-top: 16px;
        border-top:
          1px solid rgba(255,255,255,.16);
        color:
          rgba(255,255,255,.76) !important;
        font-size: 10px;
        line-height: 1.55;
      }

      .eco-mc-actions {
        display: grid;
        grid-template-columns:
          1fr 1fr;
        gap: 10px;
        margin-top: 18px;
      }

      .eco-mc-action-main,
      .eco-mc-action-secondary {
        min-height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 11px;
        text-decoration: none;
        font-size: 12px;
        font-weight: 800;
      }

      .eco-mc-action-main {
        background: #fff;
        color: #047857;
      }

      .eco-mc-action-secondary {
        border:
          1px solid rgba(255,255,255,.40);
        color: #fff;
      }

      .eco-mc-error {
        padding: 30px;
        border:
          1px solid #fed7aa;
        border-radius: 18px;
        background: #fff7ed;
        color: #9a3412;
      }

      .eco-mc-error strong,
      .eco-mc-error span {
        display: block;
      }

      .eco-mc-error span {
        margin-top: 6px;
        font-size: 12px;
      }

      /*
       * HERO automatikus kép
       */

      .eco-bb-auto-phone-image {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .eco-bb-auto-phone-image img {
        width: 100%;
        max-width: 520px;
        max-height: 530px;
        object-fit: contain;
      }

      @media (max-width: 749px) {

        .eco-mc-options {
          grid-template-columns:
            1fr 1fr;
        }

        .eco-mc-storage-options {
          grid-template-columns:
            1fr 1fr;
        }

        .eco-mc-actions {
          grid-template-columns:
            1fr;
        }

        .eco-mc-model {
          align-items:
            flex-start;
          flex-direction:
            column;
        }

        .eco-bb-auto-phone-image img {
          max-width: 380px;
          max-height: 400px;
        }

      }

    `;


    document.head.appendChild(
      style
    );
  }


  /*
   * ============================================================
   * START
   * ============================================================
   */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      init
    );

  } else {

    init();

  }

})();